import { supabase } from '@/integrations/supabase/client';
import { CalculatorRequest } from '@/types/submission';

// Function to submit calculator request
export const submitCalculatorRequest = async (email: string, description: string): Promise<CalculatorRequest[]> => {
  try {
    // Don't use .select() — anon users lack SELECT permission (admin-only)
    const { error } = await supabase
      .from('calculator_requests')
      .insert([
        {
          email,
          description,
          status: 'pending',
        },
      ]);

    if (error) {
      throw error;
    }

    return [];
  } catch (err) {
    console.error('Error submitting calculator request:', err);
    throw err;
  }
};

// Function to test the Supabase connection
export const testSupabaseConnection = async () => {
  try {
    const { data, error } = await supabase
      .from('calculator_requests')
      .select('id')
      .limit(1);
      
    if (error) {
      return { 
        success: false, 
        message: `Connection error: ${error.message}`,
        details: error
      };
    }
    
    return { 
      success: true, 
      message: 'Successfully connected to Supabase',
      tableExists: true
    };
  } catch (e) {
    return { 
      success: false, 
      message: `Unexpected error: ${e instanceof Error ? e.message : String(e)}`,
      error: e
    };
  }
};
